import { isMajor } from '@rolebase/shared/model/release'

// #77 — what members see of the releases Yohan published in the console.
// Hasura already keeps only the published versions and their kept cards
// (public_release*.yaml); this decides what to show and to whom.

interface ItemLike {
  proposedText: string
  editedText?: string | null
  sortColumn: string
}

interface ReleaseLike {
  version: string
  publishedAt?: string | null
}

// A card as members read it: rewritten when Yohan adjusted it
export function itemText(item: ItemLike): string {
  return item.sortColumn === 'edit' && item.editedText?.trim()
    ? item.editedText
    : item.proposedText
}

// The « update done » banner: the newest published version, if it is a MAJOR
// one, once per person, never for an account created after its publication
// (grilling of 27/09/2026). The newest overall, not the newest major: the
// versions delivered before #77 come in already published with their real
// dates, and a v2.0.0 must not be announced again behind a v2.1.0.
export function releaseToAnnounce<R extends ReleaseLike>(
  releases: R[],
  userCreatedAt: string | undefined,
  lastSeenRelease: string | undefined
): R | undefined {
  const latest = releases
    .filter((r) => r.publishedAt)
    .sort(
      (a, b) =>
        new Date(b.publishedAt!).getTime() - new Date(a.publishedAt!).getTime()
    )[0]
  if (!latest || !isMajor(latest.version)) return undefined
  if (latest.version === lastSeenRelease) return undefined
  if (
    userCreatedAt &&
    new Date(userCreatedAt) >= new Date(latest.publishedAt!)
  ) {
    return undefined
  }
  return latest
}
